import { Component } from '@angular/core';
import { SaveIndicatorFacade } from '@mode/report-viewer/domain';
/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector: 'mode-save-indicator',
  template: `
    <div>
      <p class="saving" *ngIf="saveIndicatorFacade.isSaving$ | async">Saving...</p>
      <p class="saved" *ngIf="saveIndicatorFacade.isSaved$ | async"><span class="dot"></span>Saved</p>
      <p class="error" *ngIf="saveIndicatorFacade.hasError$ | async"><span class="dot"></span>Save was unsuccessful</p>
    </div>
  `,
  styleUrls: ['./save-indicator.component.scss'],
})
export class SaveIndicatorComponent {
  constructor(public saveIndicatorFacade: SaveIndicatorFacade) {}
}
